// src/components/voice-of-the-customer/voice-of-the-customer.tsx
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment voiceOfTheCustomerFragment on VoiceOfTheCustomer {\n    label\n    displayAction\n    accessibilityMessage\n    relativeURI {\n      value\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  query VoiceOfTheCustomerQuery($context: ContextInput!, $surveyContext: String, $additionalParams: [GraphQLPairInput!]) {\n    voiceOfTheCustomerOptional(context: $context, surveyContext: $surveyContext, additionalParams: $additionalParams) {\n      ...voiceOfTheCustomerFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import React2 from "react";
import { gql as gql2, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
// src/components/voice-of-the-customer/__private/__fragments/voice-of-the-customer-container.tsx
import React from "react";
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkSecondaryButton } from "uitk-react-button";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var buttonSpacingProps = {
    margin: {
        blockstart: "two",
        blockend: "three"
    }
};
var containerSpacingProps = {
    margin: {
        blockend: "six"
    }
};
var leftPositionModifier = 535;
var topPositionModifier = 192;
var width = "640px";
var height = "700px";
var windowDimensions = {
    getLeft: function(lWidth) {
        return (lWidth - leftPositionModifier) / 2;
    },
    getTop: function(tHeight) {
        return (tHeight - topPositionModifier) / 2;
    },
    width: width,
    height: height
};
var VoiceOfTheCustomerContainer = function(param) {
    var data = param.data;
    var trackClick = useClickTracker();
    var label = data.label, analytics = data.analytics, accessibilityMessage = data.accessibilityMessage, displayAction = data.displayAction, relativeURI = data.relativeURI;
    var handleClick = React.useCallback(function(e) {
        e.preventDefault();
        var leftPosition = windowDimensions.getLeft(screen.width);
        var topPosition = windowDimensions.getTop(screen.height);
        window.open(relativeURI.value, "ModalPopUp", "toolbar=no,\n        scrollbars=no,\n        location=no,\n        statusbar=no,\n        menubar=no,\n        resizable=no,\n        width=".concat(windowDimensions.width, ",\n        height=").concat(windowDimensions.height, ",\n        screenX=").concat(leftPosition, ",\n        screenY=").concat(topPosition, ",\n        left=").concat(leftPosition, ",\n        top=").concat(topPosition));
        window.focus();
        trackClick(analytics.referrerId, analytics.linkName);
    }, [
        analytics.linkName,
        analytics.referrerId,
        trackClick,
        relativeURI.value
    ]);
    return /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: containerSpacingProps.margin
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlex, {
        alignItems: "center",
        direction: "column",
        "data-stid": "voice-of-the-customer"
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkText, {
        size: 200,
        weight: "bold",
        inline: true
    }, label)), /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: buttonSpacingProps.margin,
        padding: buttonSpacingProps.padding
    }, /* @__PURE__ */ React.createElement(UitkSecondaryButton, {
        tag: "a",
        "data-stid": "goto-voice-of-the-customer-button",
        "aria-label": accessibilityMessage,
        onClick: handleClick,
        href: relativeURI.value,
        target: "_blank",
        rel: "noopener"
    }, displayAction)))));
};
VoiceOfTheCustomerContainer.fragment = fragment;
VoiceOfTheCustomerContainer.displayName = "VoiceOfTheCustomerContainer";
// src/components/voice-of-the-customer/voice-of-the-customer.tsx
var __Query = gql2(_templateObject1(), VoiceOfTheCustomerContainer.fragment);
var VoiceOfTheCustomer = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !(data === null || data === void 0 ? void 0 : data.voiceOfTheCustomerOptional)) {
        return null;
    }
    return /* @__PURE__ */ React2.createElement(VoiceOfTheCustomerContainer, {
        data: data.voiceOfTheCustomerOptional
    });
};
VoiceOfTheCustomer.displayName = "sharedui-VoiceOfTheCustomer";
export { VoiceOfTheCustomer };
//# sourceMappingURL=index.js.map